export default class Customer {
  constructor(args) {
    this.email = args.email // string
    this.phone = args.phone // string
    this.pid = args.pid // number
  }
}
